/* @flow */
import React from 'react';
// $FlowIgnore
import { MdFileDownload } from 'react-icons/md';

export default function DownloadIcon({
  style
}: Object): React.Element {
  return <MdFileDownload style={style} />;
}
